const capitalizeFun = (sentence) => {
  const words = sentence.split(" ");
  const filteredWords = words.filter(Boolean);

  return filteredWords
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(" ");
};

export default capitalizeFun;